import React from 'react';

import {callHiddenNav} from '../../utils/utils';
import './HambergerForHiddenNav.scss';
import HamburgerIcon from "../../../img/gnb_menu_40.svg"
import {HambergerIconColor} from "../../../assets/HambergerIcon";

const HambergerForHiddenNavColor: React.FunctionComponent<{ className?: string, color: string }> =
    ({
         ...otherProps
     }) => {
        return (
            <div style={{cursor: 'pointer', alignItems: 'center'}}
                 onClick={() => {
                     callHiddenNav();
                 }}

                 className={`hamberger ${otherProps.className}`}>
                <HambergerIconColor color={otherProps.color}/>
            </div>

        );
    };

export default HambergerForHiddenNavColor;
